export const amplitudeEvents = {
    Doctors_Name_Updated: "Doctors_Name_Updated",
    Doctors_Contact_Numbers_Updated: "Doctors_Contact_Numbers_Updated",
    Doctors_Email_Updated: "Doctors_Email_Updated",
    Doctors_About_Me_Updated: "Doctors_About_Me_Updated"
};